import { literal } from 'zod';

import { BasePromotionSchema } from './base-promotion.schema';

// Schema for the initial form state before any `offerType` is selected.
export const DraftPromotionSchema = BasePromotionSchema.extend({
  offerType: literal(null),
});
